import { faChevronDown, faChevronUp, faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Disclosure } from '@headlessui/react';
import { memo, PropsWithChildren } from 'react';

import Sort from '@/components/Sort';
import { OptionType } from '@/ui/components/Form/Select/types';

import type { Props } from './types';

const FiltersBar = ({ children, filterSets, search, sort }: PropsWithChildren<Props>) => {
  return (
    <Disclosure
      as="section"
      aria-labelledby="filter-heading"
      className="grid items-center border-t border-gray-200 py-1">
      {({ open }) => (
        <>
          <h2 id="filter-heading" className="sr-only">
            Filters
          </h2>

          <div className="relative">
            <div className="flex items-center justify-between max-w-7xl space-x-2 divide-x divide-gray-200 text-sm">
              {search && <div className="mb-1 grow">{search}</div>}

              <Disclosure.Button className="group flex items-center font-medium text-gray-700 pl-1 pr-2">
                <FontAwesomeIcon className="mr-1" icon={faFilter} />
                Filters
                <FontAwesomeIcon className="ml-1" icon={open ? faChevronUp : faChevronDown} />
              </Disclosure.Button>

              {sort && (
                <div className="pl-1">
                  <Sort
                    onChange={sort.onChange as (value: OptionType) => void}
                    sortOptions={sort.sortOptions}
                    value={sort.value}
                  />
                </div>
              )}
            </div>
          </div>

          <Disclosure.Panel>{filterSets}</Disclosure.Panel>

          {children}
        </>
      )}
    </Disclosure>
  );
};
export default memo(FiltersBar);
